import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTransunionIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			rx: 8,
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_16636_7031)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M35.9924 23.9328C35.9924 30.5783 30.5632 35.9909 23.8957 35.9909C17.9847 35.9909 13.1049 31.7439 12.0046 26.1938L13.9289 25.7829C14.8236 30.4423 18.9468 34.0049 23.8957 34.0049C29.4629 34.0049 33.999 29.4829 33.999 23.9328C33.999 18.3827 29.4629 13.8608 23.8957 13.8608C20.3908 13.8608 17.3663 15.6421 15.511 18.314V18.3827C14.9601 19.3421 14.7545 20.164 14.9601 20.575C15.1673 20.9172 15.5786 21.1234 16.266 21.1234H18.4665L19.4977 17.903H21.5586L20.5274 21.1234H22.8645L22.2461 23.1109H19.8399L19.0849 25.4391C18.9468 25.9188 19.0159 26.3313 19.2215 26.6048C19.4287 26.947 19.8399 27.0157 20.1161 27.0157C20.5965 27.0157 21.0783 26.947 21.4895 26.7422C21.4895 27.0845 21.6277 27.3579 21.6967 27.6329C21.8333 27.9751 21.9714 28.2486 22.177 28.5235C21.4895 28.797 20.7346 28.9345 20.0471 28.9345C19.0159 28.9345 18.1903 28.5235 17.641 27.7689C17.0916 27.0157 16.9535 25.8516 17.2972 24.8235L17.8481 23.1109H16.3351C15.511 23.1109 13.9289 22.9734 13.243 21.7406C12.6231 20.7125 12.7612 19.4796 13.5177 18.0405C15.5786 14.4092 19.4977 12.0107 23.9647 12.0107C30.6323 12.0107 36.0614 17.4233 35.9924 23.9328Z",
				fill: "#00A6CA"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M32.4875 27.2219C32.4185 27.2891 32.4185 27.4266 32.3494 27.4954C32.2809 27.6329 32.2123 27.7699 32.1438 27.9063C32.0752 28.0438 32.0067 28.1808 31.9381 28.3173C31.8686 28.4548 31.7995 28.5918 31.731 28.7282C31.6619 28.797 31.6619 28.8657 31.5944 28.9345C31.5254 28.9345 31.2507 29.0032 31.0435 29.0032C30.5632 29.0032 30.1504 29.0032 29.463 28.797C28.9826 28.5923 28.6389 28.3173 28.3627 27.9063C27.5387 28.5923 26.5075 29.0032 25.5453 29.0032C24.5141 29.0032 23.7591 28.5923 23.2082 27.9063C22.6589 27.1532 22.5208 26.125 22.8645 25.1657L24.1704 21.1921H26.2328L24.7213 25.7828C24.5141 26.2625 24.6522 26.536 24.7888 26.7422C24.9269 27.0157 25.2706 27.0844 25.5453 27.0844C26.5075 27.0844 27.6077 26.2625 27.9514 25.2344L29.2573 21.2609H31.3182L29.8067 25.8516C29.7376 26.0563 29.7376 26.2625 29.7376 26.3985C29.8067 26.7422 30.0123 26.8782 30.1504 27.0157C30.5632 27.2891 31.1816 27.3579 31.6619 27.3579C32.0057 27.3579 32.2819 27.3579 32.4875 27.2219Z",
				fill: "#00A6CA"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_16636_7031",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white",
				transform: "translate(12 12)"
			})
		}) })
	]
});
export default SvgTransunionIcon;
